/* eslint-disable react/jsx-pascal-case */
// base_info_view 4 
import React, { useRef, useState, useEffect } from 'react'
import BaseInfoView4_1 from './base_info_view_4_1'
import BaseInfoView4_2 from './base_info_view_4_2'
import { Row, Col } from "./ot"
const BaseInfoView4 = ({
    baseInfoView4_1_props = {
        checkedAll: false,
        onToggleAll: () => { },
        selectedCount: 0,
        selectedTotal: 0,
        actionList: [{ label: "批次刪除", value: "delete" }],
        onActionClick: () => { },
        selectLabel: "選擇本頁所有項目",
        selectCountBadge: true,
        getcheckboxJSX: () => { }, //取得checkbox
        showComponent: ["BaseBulkActionControl1_1", "BaseBulkActionControl1_2", "BaseBulkActionControl1_3"]
    },
    baseInfoView4_2_props = {

    },
    showComponent = ['BaseInfoView4_1', 'BaseInfoView4_2']
}) => {
    const [checkboxJSX, setCheckboxJSX] = useState(null)

    return (<div className="space-y-1">
        {showComponent.includes("BaseInfoView4_1") &&
            <BaseInfoView4_1
                baseBulkActionControl1Props={{
                    selectedCount: 0,
                    selectedTotal: 0,
                    actionList: [{ label: "批次刪除", value: "delete" }],
                    onActionClick: () => { },
                    selectLabel: "選擇本頁所有項目",
                    selectCountBadge: true,
                    getcheckboxJSX: (checkboxJSX) => { setCheckboxJSX(checkboxJSX) },
                    ...baseInfoView4_1_props
                }}
            />}
        <Row justify="space-between">
            {showComponent.includes("BaseInfoView4_1") && <Col>
                {checkboxJSX}
            </Col>}
            {showComponent.includes("BaseInfoView4_2") && <Col>
                <BaseInfoView4_2
                    {...baseInfoView4_2_props}
                />
            </Col>}
        </Row>
    </div>)
}
export default BaseInfoView4
